import SearchResults from '../entities/SearchResults';
import Inventory from '../entities/Inventory';
import { url } from './index';

type GetSearchResultsOptions = {
  signal?: AbortSignal;
};

export default async function getSearchResults(
  searchTerm: string,
  options: GetSearchResultsOptions = {},
): Promise<SearchResults> {
  const uri = url('get-search-results');

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ term: searchTerm }),
    ...options,
  };

  const response = await fetch(uri, fetchOptions);

  if (!response.ok) {
    throw new Error('Failed to retrieve the trade-in search results');
  }

  const { data } = await response.json();

  const results = data.products.map((inventory: any) => new Inventory(
    inventory.inventoryID,
    inventory.title,
    inventory.imageUrl,
    inventory.canBeTraded,
  ));

  return new SearchResults(...results);
}
